import { Navigate } from "react-router-dom";
import useIsAuth from "../hooks/useIsAuth";

export const ProtectedRoute = ({ children }) => {
  const isAuth = useIsAuth();
  const user = JSON.parse(localStorage.getItem("user"));
  if (!isAuth) {
    // user is not authenticated
    return <Navigate to="/" />;
  }
  if (isAuth) {
    if (user.profile === "ajna_student") {
      return <Navigate to="/" />;
    }
    if (user.profile === "recruiter") {
      return children;
    }
  }
};
